import { MVUAction } from 'common/MVUAction';
import { CLAIM_INFO_CODE } from 'components/ProviderData/utils/Constants';

export interface ClaimDepartmentFormState {
    startDate: Date | undefined;
    department: string;
    claimAddressControlFlag: boolean;
    isClaimAddressFlag: boolean;
}

export const initialClaimDepartmentFormState: ClaimDepartmentFormState = {
    startDate: undefined,
    department: CLAIM_INFO_CODE,
    claimAddressControlFlag: false,
    isClaimAddressFlag: false,
};

interface StartDate extends MVUAction<Date | undefined> {
    type: 'StartDate';
}

interface Department extends MVUAction<string> {
    type: 'Department';
}

interface ClaimAddressControlFlag extends MVUAction<boolean> {
    type: 'ClaimAddressControlFlag';
}

interface IsClaimAddressFlag extends MVUAction<boolean> {
    type: 'IsClaimAddressFlag';
}

type ClaimDepartmentFormActions = StartDate | Department | ClaimAddressControlFlag | IsClaimAddressFlag;

export const updateClaimDepartmentFormState = (
    state: ClaimDepartmentFormState,
    action: ClaimDepartmentFormActions,
): ClaimDepartmentFormState => {
    switch (action.type) {
        case 'StartDate':
            return { ...state, startDate: action.payload };
        case 'Department':
            return { ...state, department: action.payload };
        case 'ClaimAddressControlFlag':
            return { ...state, claimAddressControlFlag: action.payload };
        case 'IsClaimAddressFlag':
            return { ...state, isClaimAddressFlag: action.payload };
        default:
            return state;
    }
};
